<template>
    <div class="bg-grey-lighter depend-on-section border-1 ml-5 p-2">
        <!-- Depend On Type -->
        <b-form-group label="Depending On..." v-slot="{ ariaDescribedby }" class="sync-depend-radio-button">
            <b-form-radio v-for="dependType in syncDependTypeOptions"
                          :key="type+'-sync-depend-'+dependType.id"
                          v-model="syncSetting.depends"
                          :aria-describedby="ariaDescribedby"
                          :name="type+'-sync-depend-'+dependType.id"
                          :value="dependType.id"
                          :disabled="dependType.id === 'update' && !pushAllowed"
                          stacked>
                <div class="radio-label">
                    <p class="radio-title">{{ dependType.label }}</p>
                    <small v-if="dependType.id === 'time-interval'" class="radio-description">{{ `Sync ${typeFormattedLabel} at regular time intervals in a set direction`}}</small>
                    <small v-if="dependType.id === 'update'" class="radio-description">{{ `When a ${typeLabel} gets saved in Followup, push to ${connectedERPName}` }}</small>

                    <!-- Time Interval -->
                    <div v-if="syncSetting.depends === 'time-interval' && dependType.id === 'time-interval'">
                        <div class="mt-2 mb-3">
                            <label>Time Interval</label>
                            <b-form-select
                                v-model="syncSetting.timeInterval.type"
                                :options="timeIntervalTypes"
                                value-field="id"
                                text-field="label"
                            ></b-form-select>
                        </div>
                        <div v-if="syncSetting.timeInterval.type === 'custom'" class="d-flex align-items-center justify-content-center mt-2 mb-3">
                            <label class="w-1/3 mb-0">Sync every</label>
                            <b-form-input
                                type="number" min="1" class="w-1/3"
                                v-model="syncSetting.timeInterval.timeNumber"
                                @input="filterTimeIntervalNumber">
                            </b-form-input>
                            <b-form-select
                                v-model="syncSetting.timeInterval.timeUnit"
                                :options="timeIntervalUnitTypes"
                                value-field="id"
                                text-field="label"
                                class="w-1/3"
                            ></b-form-select>
                        </div>
                        <div class="mt-2 mb-3">
                            <label>Direction</label>
                            <b-form-select
                                v-model="syncSetting.timeInterval.direction"
                                :options="timeIntervalDirectionOptions"
                                value-field="id"
                                text-field="label"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
            </b-form-radio>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: 'erp-sync-setting-automatic-sync',
    props: ['type', 'typeLabel', 'syncDependTypes', 'timeIntervalTypes', 'timeIntervalUnitTypes', 'timeIntervalDirectionTypes', 'syncSettings',
            'isProjectPushAllowed', 'isProjectSyncAllowed', 'isCompanyPushAllowed', 'isCompanySyncAllowed', 'isResidentialContactPushAllowed',
            'isResidentialContactSyncAllowed', 'isChangeOrderPushAllowed', 'isChangeOrderSyncAllowed', 'isWorkOrderPushAllowed', 'isWorkOrderSyncAllowed',
            'connectedErpIntegration', 'isJCContractSyncAllowed', 'connectedERPName'],
    data() {
        return {
            syncSetting: this.syncSettings
        }
    },
    computed: {
        typeFormattedLabel() {
            let label = this.typeLabel;

            if(this.typeLabel === 'project') {
                label = 'projects';
            }
            if(this.typeLabel === 'company') {
                label = 'companies';
            }

            return label;
        },
        pushAllowed() {
            if(this.type === 'project') {
                return this.isProjectPushAllowed;
            }
            else if(this.type === 'company') {
                return this.isCompanyPushAllowed;
            }
            else if(this.type === 'residentialContact') {
                return this.isResidentialContactPushAllowed;
            }
            else if(this.type === 'changeOrder') {
                return this.isChangeOrderPushAllowed;
            }
            else if(this.type === 'workOrder') {
                return this.isWorkOrderPushAllowed;
            }
        },
        syncAllowed() {
            if(this.type === 'project') {
                return this.isProjectSyncAllowed;
            }
            else if(this.type === 'company') {
                return this.isCompanySyncAllowed;
            }
            else if(this.type === 'residentialContact') {
                return this.isResidentialContactSyncAllowed;
            }
            else if(this.type === 'changeOrder') {
                return this.isChangeOrderSyncAllowed;
            }
            else if(this.type === 'workOrder') {
                return this.isWorkOrderSyncAllowed;
            }
            else if(this.type === 'jcContract') {
                return this.isJCContractSyncAllowed;
            }
        },
        timeIntervalDirectionOptions() {
            let options = _.cloneDeep(this.timeIntervalDirectionTypes);

            if(!this.pushAllowed) {
                const index = options.findIndex(option => option.id === "pull-from-followup");
                if(index !== -1) {
                    options.splice(index, 1);
                }
                this.syncSetting.timeInterval.direction = "pull-from-erp";
            }
            else if(!this.syncAllowed) {
                const index = options.findIndex(option => option.id === "pull-from-erp");
                if(index !== -1) {
                    options.splice(index, 1);
                }
                this.syncSetting.timeInterval.direction = "pull-from-followup";
            }

            if((this.type === 'changeOrder' && this.connectedErpIntegration !== 'spectrum') || this.type === 'workOrder' || this.type === 'jcContract') {
                const index = options.findIndex(option => option.id === "pull-from-followup");
                if(index !== -1) {
                    options.splice(index, 1);
                }
            }

            options.forEach(item => {
                if(item.id === 'pull-from-erp') {
                    item.label = 'Pull from ' + this.connectedERPName;
                }
            });

            return options;
        },
        syncDependTypeOptions() {
            let options = _.cloneDeep(this.syncDependTypes);

            if((this.type === 'changeOrder' && this.connectedErpIntegration !== 'spectrum') || this.type === 'workOrder' || this.type === 'jcContract') {
                const index = options.findIndex(option => option.id === "update");
                if(index !== -1) {
                    options.splice(index, 1);
                }
            }

            return options;
        }
    },
    watch: {
        syncSetting: {
            handler: function(val) {
                this.$emit('syncSettingChanged', val, this.type);
            },
            deep: true
        }
    },
    methods: {
        filterTimeIntervalNumber(event) {
            this.syncSetting.timeInterval.timeNumber = event.replace(/[^0-9]/g, "");
        }
    }
}
</script>

<style scoped>
.depend-on-section {
    border-radius: 4px;
}
.sync-depend-radio-button .custom-control {
    display: block !important;
}
</style>
